import { Fragment, useState } from "react";

const ApproveWithdrawalRequests = ({ properties, onCloseModal }) => {
  const { reference, handleSubmit, loading, handleDecline } = properties;

  const handleApprove = (e) => {
    e.preventDefault();
    handleSubmit({ reference: reference, comment: comment, otp: otp });
  };
  const handleReject = (e) => {
    e.preventDefault();
    handleDecline({ reference: reference, comment: comment });
  };
  const [otp, setOtp] = useState("");
  const [comment, setComment] = useState("");

  return (
    <div
      className="AuditTrailModal Modal__content"
      style={{ overflow: "hidden" }}
    >
      <div className="Modal__body">
        <Fragment>
          <h3 className="Modal__title p-b-1">Two Factor Authentication</h3>
          <hr />
          <form onSubmit={handleApprove}>
            <div className="row">
              <div className="col-12 mb-1">
                <label>Generated 2FA</label>
                <input
                  type="text"
                  className="form-control"
                  name="otp"
                  defaultValue={otp}
                  onChange={(e) => setOtp(e.target.value)}
                ></input>
              </div>
              <div className="col-12 mb-1">
                <label>Referrence</label>
                <input
                  type="text"
                  className="form-control"
                  name="reference"
                  defaultValue={reference}
                  disabled
                ></input>
              </div>
              <div className="col-12 mb-1">
                <label>Comment</label>
                <input
                  type="text"
                  className="form-control"
                  name="comment"
                  defaultValue={comment}
                  onChange={(e) => setComment(e.target.value)}
                ></input>
              </div>
              <div className="col-12 d-flex justify-content-end flex-wrap">
                <button
                  className="btn advancly-dimred-btn btn-sm transition-3d-hover mt-2"
                  type="submit"
                  disabled={loading || !comment || !reference}
                  onClick={handleReject}
                >
                  Decline
                </button>
                <button
                  className="btn advancly-btn btn-sm transition-3d-hover mt-2"
                  type="submit"
                  disabled={loading || !comment || !otp || !reference}
                  onClick={handleApprove}
                >
                  Approve
                </button>
              </div>
            </div>
          </form>
        </Fragment>
      </div>
    </div>
  );
};
export default ApproveWithdrawalRequests;
